(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ig-section-space"] && !Shopify.designMode) return;
  try {
    
 window.addEventListener('load', async (event) => {
  try{
 	const generateCard = (post,width) => {
	if(post.mediaType === "VIDEO"){
		return '';
	}
debugger;
      return `
        <div class="ig-card" style="width:${width}%">
          <img class="image" draggable="false" src="${post.mediaUrl}" alt="Random">
          </img>
          <div class="description-holder">
            <div class="text">${post.caption}</div>
          </div>
        </div>`;
	};
  const getWidthOfCard = (widthOfSection)=>{

    let defalutWidth = 25;
    if(widthOfSection >= 50 && widthOfSection < 90){
      defalutWidth = 100 / 3;
    }
    if(widthOfSection < 50 && widthOfSection >= 25){
      defalutWidth = 100 / 2;
    }
     if(widthOfSection === 25){
      defalutWidth = 100;
    }
    return parseFloat(defalutWidth.toFixed(2));
  };
	const store = window.location.host;
	const htmlElement = document.getElementById('container');
	const titleElement = document.getElementById('main-title');
	const response = (await axios.default.get('http://shopify.alertate.uy/user/userFeed?shopifyStore='+store)).data;
	titleElement.innerText = response.title;
  htmlElement.style.width = `${response.widthOfSection}%`
	response.message.forEach((post) => {
		htmlElement.insertAdjacentHTML('beforeend',generateCard(post, getWidthOfCard(response.widthOfSection)));
	});
  }catch(e){
  console.log(e.message);
  }


});

  } catch(e) { console.error(e); }
})();
})();
